
export function normalizeCommunityName(name) {
    name = name?.toLowerCase() || 'all';
    return name === 'all' ? 'win' : name;
}

export function isPseudoCommunity(name) {
    name = name?.toLowerCase() || 'win';
    return name === 'win' || name === 'all' || name === 'home' || name === 'trending';
}
